export default __webpack_public_path__ + "static/media/phantom-logo.b634811e.svg";